import {makeStyles} from "@mui/styles";
import {
  AppBar,
  Box, Button, Chip, Fade,
  IconButton, InputAdornment, Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText, Modal,
  SwipeableDrawer, TextField,
  Toolbar
} from "@mui/material";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import React, {useContext, useState} from "react";
import AuthContext from "../../contexts/AuthContext";
import {capitalize} from "lodash";
import {ShoppingCart01} from "untitledui-js/icons/finance";
import {MagicWand01} from "untitledui-js/icons/editor";
import {HeartRounded, SearchSM, XClose, Loading01} from "untitledui-js/icons/general";
import CartContext from "../../contexts/CartContext";
import './MobileAppBar.scss'
import SearchBoard from "../Shop/SearchBoard";
import SearchIcon from "../../icons/SearchIcon";

export const useStyles = makeStyles(() => ({
	header: {
		border: 0,
	},
  chip: {
    "&.MuiChip-root": {
      cursor: "pointer",
      color: "#FF99E9",
      borderRadius: 6,
      backgroundColor: "#FFE5F9"
    },
  },
  tier: {
    display: "flex",
    padding: "5px 8px",
    justifyContent: "center",
    alignItems: "center",
    gap: 6,
    height: '22px',
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 600,
    background: "#E8F6EE",
    color: "#3F6C51",
  }
}));

const MobileAppBar = ({handleOpenTokensPurchaseModal}) => {

  const auth = useContext(AuthContext);
  const classes = useStyles();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const cart = useContext(CartContext);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen)
  }

  const handleClickTryFree = () => {
    if (!auth.user) {
      auth.signInForm();
    } else {
      navigate('/');
      navigate(0);
    }
  }

  return (
    <>
      <AppBar elevation={0} position="static" className={classes.header + ' MobileHeader'}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }} className={'MobileHeader__Left'}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleMenu} className={'MobileHeader__MenuButton'}>
              <MenuIcon />
            </IconButton>
            <Box sx={{width: 200}} className={'MobileHeader__Logo'}>
              <Box component={RouterLink} to="/">
                  <svg width="90" height="30" viewBox="0 0 90 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30.438 14.9812C30.438 23.1157 23.8436 29.71 15.7092 29.71C7.57475 29.71 0.980469 23.1157 0.980469 14.9812C0.980469 6.84678 7.57475 0.252502 15.7092 0.252502C23.8436 0.252502 30.438 6.84678 30.438 14.9812Z" fill="#FF99E9" fill-opacity="0.8"/>
                    <path d="M26.1236 14.9992C26.1236 20.7406 21.4693 25.3949 15.7279 25.3949C9.98638 25.3949 5.33203 20.7406 5.33203 14.9992C5.33203 9.2577 9.98638 4.60336 15.7279 4.60336C21.4693 4.60336 26.1236 9.2577 26.1236 14.9992Z" fill="#FF66DE" fill-opacity="0.7"/>
                    <path d="M21.7936 15.0001C21.7936 18.3496 19.0783 21.0649 15.7288 21.0649C12.3793 21.0649 9.66406 18.3496 9.66406 15.0001C9.66406 11.6506 12.3793 8.93534 15.7288 8.93534C19.0783 8.93534 21.7936 11.6506 21.7936 15.0001Z" fill="#FF2BD1"/>
                    <path d="M45.4308 14.792C46.5928 14.792 47.4048 14.246 47.4048 13.154C47.4048 12.062 46.6348 11.558 45.4728 11.558H43.8488V14.792H45.4308ZM41.9728 20V10.004H45.6128C47.8668 10.004 49.2668 11.348 49.2668 13.126C49.2668 14.96 47.6568 16.346 45.5708 16.346H43.8488V20H41.9728ZM50.4455 10.004H52.2515V20H50.4455V10.004ZM53.8895 17.186V12.762H55.6815V16.752C55.6815 17.802 55.9755 18.628 56.9975 18.628C57.9775 18.628 58.6215 17.774 58.6215 16.01V12.762H60.4275V20H58.6635V18.754C58.2715 19.594 57.6135 20.196 56.4935 20.196C54.6315 20.196 53.8895 18.964 53.8895 17.186ZM63.8853 12.762V14.036C64.2913 13.07 65.0753 12.692 66.0833 12.678V14.372C65.9853 14.372 65.4673 14.372 65.2153 14.47C64.5713 14.624 63.9273 14.974 63.9273 16.738V20H62.1213V12.762H63.8853ZM66.8231 14.974C67.0331 13.784 68.0271 12.538 69.9311 12.538C72.1991 12.538 73.0391 13.84 73.0391 15.618V18.236C73.0391 18.796 73.0811 19.538 73.1791 20H71.3731C71.3311 19.762 71.3171 19.496 71.3171 19.258V18.894H71.3031C71.0091 19.468 70.4071 20.196 69.0351 20.196C67.4531 20.196 66.5011 19.244 66.5011 18.026C66.5011 16.038 68.8811 15.842 69.8891 15.688C70.8271 15.548 71.2751 15.408 71.2751 14.792C71.2751 14.218 70.7711 13.882 69.9451 13.882C69.2311 13.882 68.6991 14.302 68.5171 14.974H66.8231ZM68.2931 17.942C68.2931 18.46 68.7131 18.866 69.5251 18.866C70.4491 18.866 71.3031 18.32 71.3031 16.64V16.024C71.1351 16.374 70.7571 16.696 69.6931 16.906C68.7271 17.102 68.2931 17.396 68.2931 17.942ZM74.6447 20V12.762H76.4087V14.008C76.8147 13.168 77.4587 12.566 78.5787 12.566C80.4547 12.566 81.1827 13.798 81.1827 15.576V20H79.3907V16.01C79.3907 14.96 79.1107 14.134 78.0747 14.134C77.1087 14.134 76.4507 14.988 76.4507 16.752V20H74.6447ZM82.7645 14.974C82.9745 13.784 83.9685 12.538 85.8725 12.538C88.1405 12.538 88.9805 13.84 88.9805 15.618V18.236C88.9805 18.796 89.0225 19.538 89.1205 20H87.3145C87.2725 19.762 87.2585 19.496 87.2585 19.258V18.894H87.2445C86.9505 19.468 86.3485 20.196 84.9765 20.196C83.3945 20.196 82.4425 19.244 82.4425 18.026C82.4425 16.038 84.8225 15.842 85.8305 15.688C86.7685 15.548 87.2165 15.408 87.2165 14.792C87.2165 14.218 86.7125 13.882 85.8865 13.882C85.1725 13.882 84.6405 14.302 84.4585 14.974H82.7645ZM84.2345 17.942C84.2345 18.46 84.6545 18.866 85.4665 18.866C86.3905 18.866 87.2445 18.32 87.2445 16.64V16.024C87.0765 16.374 86.6985 16.696 85.6345 16.906C84.6685 17.102 84.2345 17.396 84.2345 17.942Z" fill="#1A1A19"/>
                  </svg>
              </Box>
            </Box>
          </Box>

          <Box className={'MobileHeader__Right'}>
            {!auth.user &&
                <Button className={'TryForFreeButton'} component={RouterLink} onClick={handleClickTryFree}>
                  Try for Free
                </Button>
            }
            <IconButton className={'MobileHeader__Cart'} component={RouterLink} to="/shop/cart">
              <ShoppingCart01 stroke={'currentColor'} size={24}/>
              <Box className={'MobileHeader__Cart__Counter'}>
                {cart.cart?.lines ? cart.cart?.lines.length : 0}
              </Box>
            </IconButton>
            {auth.user &&
                <Link className={'Link__avatar'} component={"button"} onClick={toggleProfile}>
                  <img src="/static/images/avatar.svg" alt="Profile menu" />
                </Link>
            }
          </Box>
        </Toolbar>
      </AppBar>

      <SwipeableDrawer
        anchor="right"
        open={auth.user && isProfileOpen}
        onOpen={toggleProfile}
        onClose={toggleProfile}
        id={'MobileMenu'}
      >
        <List className={'MobileHeaderProfilePopper'}>
          <ListItem disablePadding>
            {auth.user ?
              <ListItemButton>
                <Box className={'UserInfo'}>
                  <Box className={'UserInfo__Name'}>
                    User Name{auth.user.first_name} {auth.user.last_name}
                  </Box>
                  <Box className={'UserInfo__Email'}>
                    {auth.user.email}
                  </Box>
                  <Box className={classes.tier + ' UserInfo__Tier'}>
                    {auth.user.subscription ?
                      `${capitalize(auth.user.subscription.tier.key)} Plan | $${parseInt(auth.user.subscription.tier.price)}`:
                      "Free plan"
                    }
                  </Box>
                </Box>
                {/*<ListItemIcon>*/}
                {/*  <img src="/static/images/avatar.png" alt="Profile menu" />*/}
                {/*</ListItemIcon>*/}
                {/*<ListItemText primary={auth.user.email}></ListItemText>*/}
              </ListItemButton> :

              <ListItemText>
                <ListItemButton onClick={() => {
                  toggleProfile();
                  auth.signInForm();
                }}>
                  Sign in →
                </ListItemButton>
              </ListItemText>
            }
          </ListItem>
          <div className={'MobileHeaderPopper__Separator'}/>

          {auth.user ?
            <ListItem disablePadding onClick={() => {
              toggleProfile();
              handleOpenTokensPurchaseModal("start")
            }}>
              <ListItemButton>
                <Box display="flex" justifyContent="space-between" sx={{width: "100%"}} className={'Tokens'}>
                  <Box className={'Tokens__Label'}><Loading01 size={16}/> {auth.user.tokens} tokens</Box>
                  <Chip className={'Tokens__Chip'} size="small" label="Add tokens" color="secondary" />
                </Box>
              </ListItemButton>

            </ListItem> : null }

          <ListItem disablePadding>
            <ListItemButton
                onClick={toggleProfile}
                component={RouterLink} color="text.primary"
                underline="hover" to="/"
                fontSize={"16px"}
            >
              Purchases
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component={RouterLink} to="/favorites" onClick={toggleProfile}>
              <HeartRounded size={16} style={{marginRight: 8}} stroke={'currentColor'}/>
              Saved
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              onClick={toggleProfile}
              component={RouterLink} color="text.primary"
              underline="hover" to="/terms"
              fontSize={"16px"}
            >
                Terms & Conditions
            </ListItemButton>
          </ListItem>

          <div className={'MobileHeaderPopper__Separator'}/>

          <ListItem disablePadding>
            <ListItemButton
              onClick={() => {toggleProfile(); auth.logout()}}
              color="text.primary"
              fontSize={"16px"}
            >
              Sign out
            </ListItemButton>
          </ListItem>

          <ListItem>
            <Button className={'TryForFreeButton'} onClick={handleClickTryFree} style={{minWidth: 204, marginTop: 32}}>
              Save 40% and subscribe
            </Button>
          </ListItem>

          {/*<ListItem>*/}
          {/*    <ListItemText primary="Favorites" />*/}
          {/*</ListItem>*/}
          <IconButton className={'MobileHeaderPopper__CloseButton'} onClick={toggleProfile}>
            <XClose size={18}/>
          </IconButton>
        </List>
      </SwipeableDrawer>

      <SwipeableDrawer
          anchor="left"
          open={isMenuOpen}
          onOpen={toggleMenu}
          onClose={toggleMenu}
          id={'MobileMenu'}
      >
        <List className={'MobileHeaderPopper'}>
          <ListItem>
            <Box component={RouterLink} to="/">
              <svg width="90" height="30" viewBox="0 0 90 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.438 14.9812C30.438 23.1157 23.8436 29.71 15.7092 29.71C7.57475 29.71 0.980469 23.1157 0.980469 14.9812C0.980469 6.84678 7.57475 0.252502 15.7092 0.252502C23.8436 0.252502 30.438 6.84678 30.438 14.9812Z" fill="#FF99E9" fill-opacity="0.8"/>
                <path d="M26.1236 14.9992C26.1236 20.7406 21.4693 25.3949 15.7279 25.3949C9.98638 25.3949 5.33203 20.7406 5.33203 14.9992C5.33203 9.2577 9.98638 4.60336 15.7279 4.60336C21.4693 4.60336 26.1236 9.2577 26.1236 14.9992Z" fill="#FF66DE" fill-opacity="0.7"/>
                <path d="M21.7936 15.0001C21.7936 18.3496 19.0783 21.0649 15.7288 21.0649C12.3793 21.0649 9.66406 18.3496 9.66406 15.0001C9.66406 11.6506 12.3793 8.93534 15.7288 8.93534C19.0783 8.93534 21.7936 11.6506 21.7936 15.0001Z" fill="#FF2BD1"/>
                <path d="M45.4308 14.792C46.5928 14.792 47.4048 14.246 47.4048 13.154C47.4048 12.062 46.6348 11.558 45.4728 11.558H43.8488V14.792H45.4308ZM41.9728 20V10.004H45.6128C47.8668 10.004 49.2668 11.348 49.2668 13.126C49.2668 14.96 47.6568 16.346 45.5708 16.346H43.8488V20H41.9728ZM50.4455 10.004H52.2515V20H50.4455V10.004ZM53.8895 17.186V12.762H55.6815V16.752C55.6815 17.802 55.9755 18.628 56.9975 18.628C57.9775 18.628 58.6215 17.774 58.6215 16.01V12.762H60.4275V20H58.6635V18.754C58.2715 19.594 57.6135 20.196 56.4935 20.196C54.6315 20.196 53.8895 18.964 53.8895 17.186ZM63.8853 12.762V14.036C64.2913 13.07 65.0753 12.692 66.0833 12.678V14.372C65.9853 14.372 65.4673 14.372 65.2153 14.47C64.5713 14.624 63.9273 14.974 63.9273 16.738V20H62.1213V12.762H63.8853ZM66.8231 14.974C67.0331 13.784 68.0271 12.538 69.9311 12.538C72.1991 12.538 73.0391 13.84 73.0391 15.618V18.236C73.0391 18.796 73.0811 19.538 73.1791 20H71.3731C71.3311 19.762 71.3171 19.496 71.3171 19.258V18.894H71.3031C71.0091 19.468 70.4071 20.196 69.0351 20.196C67.4531 20.196 66.5011 19.244 66.5011 18.026C66.5011 16.038 68.8811 15.842 69.8891 15.688C70.8271 15.548 71.2751 15.408 71.2751 14.792C71.2751 14.218 70.7711 13.882 69.9451 13.882C69.2311 13.882 68.6991 14.302 68.5171 14.974H66.8231ZM68.2931 17.942C68.2931 18.46 68.7131 18.866 69.5251 18.866C70.4491 18.866 71.3031 18.32 71.3031 16.64V16.024C71.1351 16.374 70.7571 16.696 69.6931 16.906C68.7271 17.102 68.2931 17.396 68.2931 17.942ZM74.6447 20V12.762H76.4087V14.008C76.8147 13.168 77.4587 12.566 78.5787 12.566C80.4547 12.566 81.1827 13.798 81.1827 15.576V20H79.3907V16.01C79.3907 14.96 79.1107 14.134 78.0747 14.134C77.1087 14.134 76.4507 14.988 76.4507 16.752V20H74.6447ZM82.7645 14.974C82.9745 13.784 83.9685 12.538 85.8725 12.538C88.1405 12.538 88.9805 13.84 88.9805 15.618V18.236C88.9805 18.796 89.0225 19.538 89.1205 20H87.3145C87.2725 19.762 87.2585 19.496 87.2585 19.258V18.894H87.2445C86.9505 19.468 86.3485 20.196 84.9765 20.196C83.3945 20.196 82.4425 19.244 82.4425 18.026C82.4425 16.038 84.8225 15.842 85.8305 15.688C86.7685 15.548 87.2165 15.408 87.2165 14.792C87.2165 14.218 86.7125 13.882 85.8865 13.882C85.1725 13.882 84.6405 14.302 84.4585 14.974H82.7645ZM84.2345 17.942C84.2345 18.46 84.6545 18.866 85.4665 18.866C86.3905 18.866 87.2445 18.32 87.2445 16.64V16.024C87.0765 16.374 86.6985 16.696 85.6345 16.906C84.6685 17.102 84.2345 17.396 84.2345 17.942Z" fill="#1A1A19"/>
              </svg>
            </Box>
          </ListItem>
          <ListItem>
            {auth.user ?
                <ListItemButton onClick={() => {
                  toggleMenu();
                  toggleProfile();
                }}>
                  Profile
                </ListItemButton>
                :
                <ListItemButton onClick={() => {
                  toggleMenu();
                  auth.signInForm();
                }}>
                  Sign in
                </ListItemButton>
            }
          </ListItem>
          <ListItem>
            <ListItemButton component={RouterLink} to="/shop/cart" onClick={toggleMenu}>
              Cart ({cart.cart?.lines ? cart.cart?.lines.length : 0})
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton component={RouterLink} to="/favorites" onClick={toggleMenu}>
              <HeartRounded size={16} style={{marginRight: 8}} stroke={'currentColor'}/>
              Saved
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton onClick={() => {toggleMenu(); setSearchOpen(true)}}>
              <SearchSM size={16} style={{marginRight: 8}} stroke={'currentColor'}/>
              Search
            </ListItemButton>
          </ListItem>
          <div className={'MobileHeaderPopper__Separator'}/>
          <ListItem>
            <ListItemButton component={RouterLink} to="/shop/catalog/freebies" onClick={toggleMenu}>
              Freebies
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton component={RouterLink} to="/shop/catalog/pattern" onClick={toggleMenu}>
              Patterns
            </ListItemButton>
          </ListItem>
          <ListItem>
            <ListItemButton component={RouterLink} to="/shop/catalog/reconstruction" onClick={toggleMenu}>
              Vectorized art
            </ListItemButton>
          </ListItem>
          <div className={'MobileHeaderPopper__Separator'}/>
          <ListItem component={RouterLink} to="/" onClick={toggleMenu}>
            <ListItemButton style={{color: '#FF66DE'}}>
              <MagicWand01 size={20} style={{marginRight: 8}} stroke={'currentColor'}/>
              Generate
            </ListItemButton>
          </ListItem>
          <ListItem component={RouterLink} to="/pricing" onClick={toggleMenu}>
            <ListItemButton>
              Pricing
            </ListItemButton>
          </ListItem>
          <ListItem>
            <Button className={'TryForFreeButton'} component={RouterLink} onClick={handleClickTryFree} style={{minWidth: 204}}>
              Try for Free
            </Button>
          </ListItem>
          <IconButton className={'MobileHeaderPopper__CloseButton'} onClick={toggleMenu}>
            <XClose size={18}/>
          </IconButton>
        </List>
      </SwipeableDrawer>

      <Modal open={searchOpen} onClose={() => setSearchOpen(false)} className={'SearchModal'}>
        <Fade in={searchOpen}>
          <Box className={'SearchModal__Wrapper'}>
            <Box className={'SearchModal__Content'}>
              <TextField sx={{
                '& .MuiInputBase-root': {
                  boxShadow: 'none',
                  background: 'none',
                  height: '58px',
                  padding: '0 0 0 16px'
                },
                '& .MuiInputBase-input': {
                  boxShadow: 'none',
                  display: 'flex',
                  background: 'none',
                  justifyContent: 'center',
                  fontSize: '16px',
                  fontWeight: '350',
                  padding: '0 0 0 2px !important',
                  color: 'rgba(153, 153, 153, 1)'
                }
              }}
                         fullWidth
                         value={searchQuery}
                         autoFocus
                         onChange={(e) => setSearchQuery(e.target.value)}
                         onBlur={() => setSearchOpen(false)}
                         placeholder={'Search'}
                         InputProps={{
                           startAdornment: (
                               <InputAdornment position="start">
                                 <SearchIcon width='16px' height='16px' color="#1A1A19" />
                               </InputAdornment>
                           ),
              }} />
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>)
}

export default MobileAppBar;